import { useRouter } from 'next/router';
import { Select, SelectOption } from '@zoopla-eng/zds-components/select';
import { useEffect, useState } from 'react';

export const SORT_KEY = 'agents_sort';

export const SORT_LABEL = 'Sort';

export const SORT_OPTIONS: SelectOption[] = [
    { id: 'a_z', text: 'Default (A-Z)' },
    { id: 'lowest_avg_price', text: 'Lowest average asking price' },
    { id: 'highest_avg_price', text: 'Highest average asking price' },
    { id: 'shortest_avg_age', text: 'Lowest average listing time' },
    { id: 'longest_avg_age', text: 'Highest average listing time' }
];

/**
 * Syncs local state with query params
 *
 * Invokes the callback (a setState function) with the option
 * in the query params if it differs from the current state.
 * Used to sync our local state with the query params on first
 * page load.
 * @param {string} queryParamValue - The query param value.
 * @param {string} selectedOptionId - The local state option id.
 * @param {function} callback - The state setter.
 */
function useSyncQueryParam(
    queryParamValue: string | string[],
    selectedOptionId: string,
    callback: (o: SelectOption) => void
) {
    useEffect(() => {
        const queryParamOption = SORT_OPTIONS.find(
            (o) => o.id === queryParamValue
        );
        if (queryParamOption && queryParamOption.id !== selectedOptionId) {
            callback(queryParamOption);
        }
    }, [queryParamValue, selectedOptionId, callback]);
}

export const SortFilter = () => {
    const { push, query } = useRouter();

    const [selectedSortOption, setSelectedSortOptionChange] = useState(
        SORT_OPTIONS[0]
    );

    useSyncQueryParam(
        query[SORT_KEY] ?? '',
        selectedSortOption.id,
        setSelectedSortOptionChange
    );

    const handleSort = (option: SelectOption) => {
        query[SORT_KEY] = option.id;

        push({ query });
        setSelectedSortOptionChange(option);
    };

    return (
        <Select
            options={SORT_OPTIONS}
            label={SORT_LABEL}
            onSelectedOptionChange={handleSort}
            selectedOption={selectedSortOption}
        />
    );
};
